import axios from "src/lib/axios"

const getInquiryPaymentAmount = () => {
  return axios.get("/api/v1/payment/getInquiryPaymentAmount")
}

const getWagePaymentAmount = () => {
  return axios.get("/api/v1/payment/getWagePaymentAmount")
}

const getTransferCreditLandings = () => {
  return axios.get("/api/v1/payment/getTransferCreditLandings")
}

const wagePaymentRequest = data => {
  return axios.post("/api/v1/payment/wagePaymentRequest", data)
}

const inquiryPaymentRequest = data => {
  return axios.post("/api/v1/payment/inquiryPaymentRequest", data)
}

const calculateWageAmountDiscount = data => {
  return axios.get("/api/v1/payment/calculateWageAmountDiscount", { params: data })
}

const calculateInquiryAmountDiscount = data => {
  return axios.get("/api/v1/payment/calculateInquiryAmountDiscount", { params: data })
}

const paymentServices = {
  getInquiryPaymentAmount,
  inquiryPaymentRequest,
  getWagePaymentAmount,
  wagePaymentRequest,
  calculateWageAmountDiscount,
  calculateInquiryAmountDiscount,
  getTransferCreditLandings
}

export default paymentServices
